import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { ModalProps } from "antd/es/modal";
import { Modal } from "antd";
import StepProgress from "./Components/StepProgress";
import StepOne from "./Components/StepOne";
import { activityBaseInfoItem, Step } from "../../../../../service/group";
import StepTwo from "./Components/StepTwo";
import StepThree from "./Components/StepThree";
import {
    ActivityIdAtom,
    emptyFormAtom,
    FlagAtom,
    PreviewAtom,
    ShowConfirmAtom,
    StepOneFormDataAtom,
    StepOneStateAtom,
    StepStateAtom,
    TouchedAtom
} from "../../store";
import { useAtom } from "jotai";
import { useAtomValue, useSetAtom } from "jotai";

interface AddGroupActivityModalProps extends ModalProps {
    initValue?: activityBaseInfoItem; //编辑时初始值
    onCancel: () => void; //关闭弹窗
    onOk: () => void; //保存
}

export default function AddGroupActivityModal({
    initValue,
    onOk,
    onCancel,
    ...props
}: AddGroupActivityModalProps) {
    const [step, setStep] = useState(0); //步骤
    const [touched, setTouched] = useAtom(TouchedAtom);
    const [activityId, setActivityId] = useAtom(ActivityIdAtom); //活动id
    const setStepOneFormData = useSetAtom(StepOneFormDataAtom);
    const setShowConfirm = useSetAtom(ShowConfirmAtom);
    const setStepState = useSetAtom(StepStateAtom);
    const setStepOneState = useSetAtom(StepOneStateAtom);
    const [preview, setPreview] = useAtom(PreviewAtom);
    const setEmptyForm = useSetAtom(emptyFormAtom);
    const flag = useAtomValue(FlagAtom);

    //当点击查看按钮时，只展示第三步内容
    useEffect(() => {
        if (preview) {
            setStep(2);
        } else {
            setStep(0);
        }
    }, [preview]);

    //点击不保存
    const onClose = () => {
        setTouched(false);
        setShowConfirm(false);
        setStepOneState("current");
        setStepState("current");
        setActivityId(-1);
        setStepOneFormData(undefined);
        setPreview(false);
        setEmptyForm(false);
        onCancel();
    };

    //点击×或取消按钮
    const handleClose = () => {
        if (touched) {
            setStepState("close");
            setStepOneState("close");
            setShowConfirm(true);
            return;
        }
        onClose();
    };

    return (
        <Modal
            title={
                preview ? "查看活动" : flag === "add" ? "添加活动" : "编辑活动"
            }
            {...props}
            width={1200}
            maskClosable={false}
            onCancel={handleClose}
            className={style.root}
            footer={null}>
            {/*点击查看的时候preview为true,此时隐藏进度条*/}
            {!preview && (
                <StepProgress
                    item={initValue}
                    step={step}
                    onChangeStep={setStep}
                    activityId={activityId}
                />
            )}

            <div className={style.container}>
                {step === Step.Step1 && !preview && (
                    <StepOne
                        item={initValue}
                        onChangeStep={setStep}
                        onOk={onOk}
                        onCancel={onClose}
                        handleClose={handleClose}
                        setActivityId={setActivityId}
                    />
                )}
                {step === Step.Step2 && !preview && (
                    <StepTwo
                        publishStatus={initValue?.publishStatus}
                        onChangeStep={setStep}
                        onCancel={onClose}
                        activityId={activityId}
                        onOk={onOk}
                    />
                )}
                {step === Step.Step3 && (
                    <StepThree
                        activityId={activityId}
                        onChangeStep={setStep}
                        onCancel={onClose}
                        onOk={onOk}
                    />
                )}
            </div>
        </Modal>
    );
}
